// Values returned by GetAccountInfo on the `planClassificationId` field.
export default Object.freeze({
	Default: 'default',
	ClosedShipper: 'closed_shipper',
	PayAsYouGo: 'pay_as_you_go',
	NewLineup: 'new_lineup',
});
